<template>
    <div>
        <div v-if="dataExist">
            <MeasurementOptions />
            <vue-good-table
                    styleClass="vgt-table condensed bordered striped"
                    :columns="tableColumns"
                    :rows="tableRows"
                    :line-numbers="true"
                    :fixed-header="false"
                    :pagination-options="{
                            enabled: true,
                            position: 'bottom',
                            perPage: 60,
                            dropdownAllowAll: false,
                            perPageDropdown: [60, 120, 240, 500, 1000, 2500],
                        }"
                    >
                <template slot="table-column" slot-scope="props">
                     <div class="data-column-header">
                        <div>{{props.column.label}}</div>
                        <div v-if="props.column.hasSubLabel" class="d-none d-lg-block" style="font-size: x-small;">[ {{props.column.subLabel}} ]</div>
                     </div>
                </template>
                <div slot="table-actions" class="mx-2">
                    <b-button variant="outline-secondary" size="sm" class="m-1" @click="downloadTable">
                        <font-awesome-icon icon="file-download"/>
                    </b-button>
                </div>
            </vue-good-table>
        </div>
        <div v-else class="text-center">
            <h5>No Measurement data available</h5>
        </div>

    </div>
</template>

<script>
    import { VueGoodTable } from 'vue-good-table';
    import { mapActions, mapGetters } from 'vuex'
    import MeasurementOptions from './MeasurementOptions'
    import dataTableUtil from "../../lib/DataTableUtil";

    export default {
        name: "MeasurementDataTableTab",
        components: {
            VueGoodTable,
            MeasurementOptions
        },
        props: [ ],
        data() {
            return {
            }
        },
        computed: {
            ...mapGetters({
                measurementDataLoading: 'measurement/isLoading',
                measurementData: 'measurement/current',
                measurementAverageInterval: 'measurement/averageInterval',
                measurementSelectedMeasurements: 'measurement/selectedMeasurements',
            }),
            elapsedSeconds: function () {
                if(this.measurementData && this.measurementData.elapsedSeconds) {
                    return this.measurementData.elapsedSeconds;
                }

                return 0
            },

            dataExist: function() {
                return this.measurementData && this.measurementData.data.find(x => x.points && x.points.length > 0) !== undefined;
            },

            enabledMeasurements: function() {

                let selected = this.measurementSelectedMeasurements;

                if(!this.dataExist || !selected) {
                    return [];
                }
                let enabled = this.measurementData.data.filter(function(item) {
                    return selected.find(x => x === item.measurementType) !== undefined;
                })

                return enabled.map(function(item) {
                    return {
                        tableName: item.shortName,
                        tableNameSecond: item.unitsName,
                        tableField: item.id,
                        points: item.averagedPoints ?? []
                    };
                });

            },
            tableColumns: function() {
                let col = [{
                    label: 'Time',
                    subLabel: 'sec',
                    hasSubLabel: true,
                    field: 'time_sec',
                    sortable: false,
                    thClass: 'data-column-header',
                }];

                col = col.concat(this.enabledMeasurements.map(function(measurement) {
                   return {
                       label: measurement.tableName,
                       subLabel: measurement.tableNameSecond,
                       hasSubLabel: !!measurement.tableNameSecond && measurement.tableNameSecond.length > 0,
                       field: measurement.tableField,
                       sortable: false,
                       thClass: 'data-column-header',
                   }
                }));

                return col;
            },
            tableRows: function() {
                let rows = [];

                let measurements = [];
                this.enabledMeasurements.forEach(function(measurement) {
                  measurements.push({ m: measurement, points: measurement.points })
                });

                if(measurements.length > 0) {

                  let interval = this.measurementAverageInterval;
                  let maxTime = this.elapsedSeconds;

                  for (let index = 0, t = interval; t < maxTime; t += interval, index++) {

                    let row = {time_sec: t, time: t * 1000};

                    measurements.forEach(function (item) {
                      row[item.m.tableField] = 0;
                      if (item.points.length > index) {
                        row[item.m.tableField] = item.points[index].valueFormatted;
                      }
                    });

                    rows.push(row);
                  }
                }

                return rows;
            },

        },
        methods: {
            ...mapActions({

            }),

            downloadTable() {
              let csv = dataTableUtil.toCSV(this.tableColumns, this.tableRows);
              dataTableUtil.beginDownload("Datatable.csv", csv);
            },
        }
    }
</script>

<style scoped>

    .data-column-header {
        font-size: 12px;
        font-weight: bold;
    }

</style>